import type { TaskType } from './Task';
import type { StatisticsScenarioMetadata } from './scenarioMapping';

interface StatisticsScenarioDefinition extends StatisticsScenarioMetadata {
  readonly type: TaskType;
}

const statisticsScenarioDefinitions: readonly StatisticsScenarioDefinition[] = [
  {
    type: 'OutboundConfirmVisit',
    groupKey: 'slotTasks',
    groupLabel: 'Задачи по слотам',
    optionLabel: 'Подтверждение приема',
    showCampaign: false,
    showQuestionnaireTemplate: false,
    variant: 'slot',
    directionSupport: 'outbound',
    isKnown: true,
  },
  {
    type: 'OutboundCancelVisit',
    groupKey: 'slotTasks',
    groupLabel: 'Задачи по слотам',
    optionLabel: 'Отмена записи по инициативе клиники',
    showCampaign: false,
    showQuestionnaireTemplate: false,
    variant: 'slot',
    directionSupport: 'outbound',
    isKnown: true,
  },
  {
    type: 'OutboundVisitRegister',
    groupKey: 'appointmentRegistration',
    groupLabel: 'Задачи по слотам — Запись на прием',
    optionLabel: 'Запись на прием',
    showCampaign: false,
    showQuestionnaireTemplate: false,
    variant: 'appointment',
    directionSupport: 'outbound',
    isKnown: true,
  },
  {
    type: 'InboundVisitRegister',
    groupKey: 'appointmentRegistration',
    groupLabel: 'Задачи по слотам — Запись на прием',
    optionLabel: 'Запись на прием',
    showCampaign: false,
    showQuestionnaireTemplate: false,
    variant: 'appointment',
    directionSupport: 'inbound',
    isKnown: true,
  },
  {
    type: 'OutboundInformingDispensarization',
    groupKey: 'dispensarization',
    groupLabel: 'Диспансеризация',
    optionLabel: 'Информирование о диспансеризации',
    showCampaign: true,
    showQuestionnaireTemplate: false,
    variant: 'dispensarization',
    directionSupport: 'outbound',
    isKnown: true,
  },
  {
    type: 'OutboundPositiveTickTest',
    groupKey: 'informing',
    groupLabel: 'Информирование',
    optionLabel: 'Информирование по клещам',
    showCampaign: true,
    showQuestionnaireTemplate: false,
    variant: 'informing',
    directionSupport: 'outbound',
    isKnown: true,
  },
  {
    type: 'GeneralInformation',
    groupKey: 'informing',
    groupLabel: 'Информирование',
    optionLabel: 'Информирование общее',
    showCampaign: true,
    showQuestionnaireTemplate: false,
    variant: 'informing',
    directionSupport: 'both',
    isKnown: true,
  },
  {
    type: 'Hotline',
    groupKey: 'informing',
    groupLabel: 'Информирование',
    optionLabel: 'Информирование о работе горячей линии',
    showCampaign: true,
    showQuestionnaireTemplate: false,
    variant: 'informing',
    directionSupport: 'both',
    isKnown: true,
  },
  {
    type: 'MonitoringDiabetesMellitus',
    groupKey: 'questionnaires',
    groupLabel: 'Анкеты',
    optionLabel: 'Мониторинг (сахарный диабет)',
    showCampaign: true,
    showQuestionnaireTemplate: true,
    variant: 'questionnaire',
    directionSupport: 'both',
    isKnown: true,
  },
  {
    type: 'MonitoringElderlyPatient',
    groupKey: 'questionnaires',
    groupLabel: 'Анкеты',
    optionLabel: 'Мониторинг (пожилые)',
    showCampaign: true,
    showQuestionnaireTemplate: true,
    variant: 'questionnaire',
    directionSupport: 'both',
    isKnown: true,
  },
  {
    type: 'MonitoringHepatitis',
    groupKey: 'questionnaires',
    groupLabel: 'Анкеты',
    optionLabel: 'Мониторинг (гепатит)',
    showCampaign: true,
    showQuestionnaireTemplate: true,
    variant: 'questionnaire',
    directionSupport: 'both',
    isKnown: true,
  },
  {
    type: 'MonitoringTuberculosis',
    groupKey: 'questionnaires',
    groupLabel: 'Анкеты',
    optionLabel: 'Мониторинг (туберкулез)',
    showCampaign: true,
    showQuestionnaireTemplate: true,
    variant: 'questionnaire',
    directionSupport: 'both',
    isKnown: true,
  },
  {
    type: 'MonitoringOncological',
    groupKey: 'questionnaires',
    groupLabel: 'Анкеты',
    optionLabel: 'Мониторинг (онко)',
    showCampaign: true,
    showQuestionnaireTemplate: true,
    variant: 'questionnaire',
    directionSupport: 'both',
    isKnown: true,
  },
  {
    type: 'MonitoringChronicObstructivePulmonaryDisease',
    groupKey: 'questionnaires',
    groupLabel: 'Анкеты',
    optionLabel: 'Мониторинг (ХОБЛ)',
    showCampaign: true,
    showQuestionnaireTemplate: true,
    variant: 'questionnaire',
    directionSupport: 'both',
    isKnown: true,
  },
  {
    type: 'MonitoringHeartFailure',
    groupKey: 'questionnaires',
    groupLabel: 'Анкеты',
    optionLabel: 'Мониторинг (хроническая сердечная недостаточность)',
    showCampaign: true,
    showQuestionnaireTemplate: true,
    variant: 'questionnaire',
    directionSupport: 'both',
    isKnown: true,
  },
  {
    type: 'MonitoringCoronaryHeartDisease',
    groupKey: 'questionnaires',
    groupLabel: 'Анкеты',
    optionLabel: 'Мониторинг (ишемическая болезнь сердца)',
    showCampaign: true,
    showQuestionnaireTemplate: true,
    variant: 'questionnaire',
    directionSupport: 'both',
    isKnown: true,
  },
  {
    type: 'MonitoringAsthma',
    groupKey: 'questionnaires',
    groupLabel: 'Анкеты',
    optionLabel: 'Мониторинг (бронхиальная астма)',
    showCampaign: true,
    showQuestionnaireTemplate: true,
    variant: 'questionnaire',
    directionSupport: 'both',
    isKnown: true,
  },
  {
    type: 'MonitoringArterialHypertension',
    groupKey: 'questionnaires',
    groupLabel: 'Анкеты',
    optionLabel: 'Мониторинг (артериальная гипертензия)',
    showCampaign: true,
    showQuestionnaireTemplate: true,
    variant: 'questionnaire',
    directionSupport: 'both',
    isKnown: true,
  },
  {
    type: 'MonitoringSarsCovid19',
    groupKey: 'questionnaires',
    groupLabel: 'Анкеты',
    optionLabel: 'Мониторинг (ОРВИ/COVID-19)',
    showCampaign: true,
    showQuestionnaireTemplate: true,
    variant: 'questionnaire',
    directionSupport: 'both',
    isKnown: true,
  },
  {
    type: 'Survey',
    groupKey: 'questionnaires',
    groupLabel: 'Анкеты',
    optionLabel: 'Анкетирование (динамическое)',
    showCampaign: true,
    showQuestionnaireTemplate: true,
    variant: 'questionnaire',
    directionSupport: 'both',
    isKnown: true,
  },
  {
    type: 'QualityEstimation',
    groupKey: 'questionnaires',
    groupLabel: 'Анкеты',
    optionLabel: 'Оценка качества услуг',
    showCampaign: true,
    showQuestionnaireTemplate: true,
    variant: 'questionnaire',
    directionSupport: 'both',
    isKnown: true,
  },
  {
    type: 'MonitoringDispensary',
    groupKey: 'slotTasks',
    groupLabel: 'Задачи по слотам',
    optionLabel: 'Мониторинг (диспансерное наблюдение)',
    showCampaign: true,
    showQuestionnaireTemplate: true,
    variant: 'slot',
    directionSupport: 'both',
    isKnown: true,
  },
  {
    type: 'Hospitalization',
    groupKey: 'slotTasks',
    groupLabel: 'Задачи по слотам',
    optionLabel: 'Напоминание о госпитализации',
    showCampaign: true,
    showQuestionnaireTemplate: true,
    variant: 'slot',
    directionSupport: 'both',
    isKnown: true,
  },
] as const;

export const statisticsScenarioByType = new Map<
  string,
  StatisticsScenarioDefinition
>(statisticsScenarioDefinitions.map((scenario) => [scenario.type, scenario]));
